<div class="spinner-wrapper">
    <div class="progress-spinner progress-spinner-double size-sm progress-spinner-active">
        <div class="progress-spinner-inner"></div>
        <div class="progress-spinner-inner"></div>
        <span class="visually-hidden">Caricamento...</span>
    </div>
</div>
<span class="color-gray">{{ ( texto || texto == '' ) ? texto : 'Caricando...'}}</span>